// returns true if the current build is the 1.0 version
export const appBuildIsOldVersion = () =>
  process.env.REACT_APP_BUILD_VERSION === "1";
